var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_75252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 0L29.9062 16.9688L52.6875 0H60V5.8125L37.5 22.5938L60 39.2812V45H52.5L30 28.2188L7.59375 45H0V39.375L22.4062 22.6875L0 6V0H7.03125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.75 26.3438L60 41.25V45L34.5938 26.3438H39.75ZM22.5 28.2188L23.0625 31.5L5.0625 45H0L22.5 28.2188ZM60 0V0.28125L36.6562 17.9062L36.8438 13.7812L55.3125 0H60ZM0 0L22.4062 16.5H16.7812L0 3.9375V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 0V45H37.5938V0H22.5938ZM0 15V30H60V15H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.0938V27.0938H60V18.0938H0ZM25.5938 0V45H34.5938V0H25.5938Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_75252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.1bcdd2e7eeaf2121cf8ddbdd2d31f7e1.svg";
export { ForwardRef as ReactComponent };